<template>
    <div v-if="is_visible">
        <div class='mcf-page-background'></div>
        <div class="mcf-dialogbox">
            <div class='mcf-dialogbox-form'>
                <div class="mcf-dialogbox-header">
                    <label><i :class='setting.icon'></i> {{setting.title}}</label>
                    <input v-if="setting.extension!='image/*'" id="mcffile" type="file" :accept="'.'+setting.extension" @change="set_file">
                    <input v-if="setting.extension=='image/*'" id="mcffile" type="file" accept="image/*" @change="set_file">
                </div>
                <div class="mcf-dialogbox-buttons">
                    <ul>
                        <li @click="bt_explore">Parcourir</li>
                        <li @click="bt_cancel">Annuler</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props:{

    },
    data(){
        return {
            is_visible:false,
            setting:{}
        };
    },
    created() {
        //document.getElementById('mcffile').click();
    },
    methods:{
        show: function(opts = {}){
            this.setting = opts;
            this.is_visible=true;
            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve;
                this.rejectPromise = reject;
            });  
        },
        set_file: function(event){
            var tmain = this;
            var reader = new FileReader();
            var file = event.target.files[0];
            
            reader.readAsDataURL(file);
            reader.onload = function(){
                var sign_data = reader.result;
                var binary_str = window.atob(sign_data.replace("data:"+file.type+";base64,",""));
                var len = binary_str.length;
                var bytes = [];
                for (var i=0;i<len;i++){
                    bytes[i] = binary_str.charCodeAt(i);
                }
                var ret = {
                    filename: file.name,
                    data: bytes
                };
                tmain.is_visible=false;
                tmain.resolvePromise({action:'upload',id:tmain.setting.id,ret:ret,file:file});
            }
            reader.onerror = function(){
                tmain.is_visible = false;
                this.resolvePromise({action:'cancel',})
            }
        },
        bt_explore: async function(){
            document.getElementById('mcffile').click();
        },
        bt_cancel: function(){
            this.is_visible=false;
            this.resolvePromise({action:'cancel',})
        }

    }
}
</script>

<style>
</style>